import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import loki, { Collection } from 'lokijs';

@Injectable()
export class DatabaseProvider {
  private communicoDB: Loki;
  constructor(private storage: Storage) {
    this.communicoDB = new loki('communico.db');
    this.loadDB();
    setTimeout(()=>this.saveDB(), 60000);
  }
  public resetDB(){
    console.log('Resetting database...');
    this.communicoDB.collections.forEach(collection=>collection.clear());
  }
  public saveDB(){
    // console.log('Saving database...');
    return this.storage.set('communico.db', JSON.stringify(this.communicoDB));
  }
  public loadDB(){
    console.log('Loading database...');
    this.storage.get('communico.db').then((val) => {
      // console.log('value', val.length, JSON.parse(val));
      this.communicoDB.loadJSON(val);
    }).catch(function(err) {
      console.log('error importing database');
    });
  }
  public get(key:string) {
    return this.storage.get(key);
  }
  public set(key: string, value:any) {
    return this.storage.set(key, value);
  }
  public getCollection(name:string):Collection{
    return this.communicoDB.getCollection(name) || this.communicoDB.addCollection(name, {unique: ["id"]});
  }
  public remove(key: string) {
    return this.storage.remove(key);
  }
}



// WEBPACK FOOTER //
// ./src/providers/database/database.ts